/**
 * Sprint Redesign v1 (Do 03.09.2026) — /videokurs (Hintergrundwissen).
 * Session 1: Wrapper um bestehende MultiKursBibliothek. Voller Umbau Session 3.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import RedesignLayout from "@/components/redesign/RedesignLayout";
import MultiKursBibliothek from "@/components/MultiKursBibliothek";

export default function PageVideoKurs() {
  const navigate = useNavigate();
  return (
    <RedesignLayout>
      {({ data }) => {
        const user = data?.user;
        return (
          <div
            className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6"
            data-testid="page-videokurs"
          >
            <header>
              <p className="text-xs font-bold uppercase tracking-widest text-[var(--fts-primary-bright)]">
                Vertiefen
              </p>
              <h1 className="mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-white">
                Hintergrundwissen
              </h1>
              <p className="mt-2 text-slate-600 dark:text-slate-300 max-w-2xl">
                Videokurse und mehr. Alles was hilft, das Vier-Fokustypen-Modell tiefer zu verstehen.
              </p>
            </header>
            <MultiKursBibliothek
              onOpenCourse={() => navigate("/dashboard/videos")}
              isPionier={!!user?.is_pionier}
              showComingSoon={false}
            />
          </div>
        );
      }}
    </RedesignLayout>
  );
}
